var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.941,
    height: 80.943,
    viewBox: "0 0 80.941 80.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.941,
    height: 80.943,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.941,
    height: 80.943,
    transform: "translate(0 0)",
    fill: "#4d9e38"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.551,23.323c2.769,0,3.972-1.469,3.972-3.731V17.185A2.508,2.508,0,0,0,13.5,14.417a2.61,2.61,0,0,0,1.878-2.648v-1.42c0-2.311-1.108-3.731-3.635-3.731C8.9,6.618,7.916,8.3,7.916,10.71v1.444h2.5V10.493c0-1.011.314-1.588,1.181-1.588s1.178.577,1.178,1.468V12.13c0,.867-.577,1.323-1.467,1.323H10.275v2.1h1.156c.962,0,1.347.456,1.347,1.323v2.7c0,.866-.385,1.469-1.227,1.469-.939,0-1.276-.627-1.276-1.589V17.113h-2.5v2.142c0,2.48.986,4.068,3.778,4.068",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.658,50.587c0-2.278-1.462-4.124-3.676-4.124-1.106,0-2.441,1.212-3.167,1.957-.725-.746-1.97-1.959-3.079-1.959a3.872,3.872,0,0,0-3.764,4.125A4.172,4.172,0,0,0,55.146,53.5l5.674,5.684,5.666-5.678,0,0a4.176,4.176,0,0,0,1.176-2.918",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,68.467a.57.57,0,0,1-.058,0,.932.932,0,0,1-.861-.772L39.7,50.907,35.333,59a.932.932,0,0,1-1.742-.31L31.738,45.737l-3.391,7.617a.931.931,0,0,1-.85.553H14.316a.932.932,0,0,1,0-1.864H26.89l4.461-10.018a.932.932,0,0,1,1.774.247l1.91,13.357,4.306-7.982a.931.931,0,0,1,1.738.284l2.669,15.546,9.728-32.312a.931.931,0,0,1,1.731-.136L60.326,41.64a.932.932,0,0,1-1.679.809L54.57,34,44.392,67.8a.931.931,0,0,1-.892.663",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.793,9.861h1.581v3.531h-.8v-.721a1,1,0,0,1-1.064.8c-.956,0-1.4-.76-1.4-1.785v-3.2A1.567,1.567,0,0,1,24.783,6.7c1.23,0,1.591.683,1.591,1.659v.585H25.359V8.271c0-.41-.156-.644-.556-.644s-.576.283-.576.683v3.551c0,.4.166.683.547.683.36,0,.546-.2.546-.634V10.739h-.527Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.36,11.861V8.31c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.458,11.861V8.31c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M31.2,11.685v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.884,12.485c.458,0,.634-.273.634-.673V8.349a.579.579,0,0,0-.634-.663h-.469v4.8ZM38.63,8.554v3.063c0,1.015-.419,1.775-1.61,1.775H35.3V6.778H37.02c1.191,0,1.61.751,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.06,10.475H41.987v2.917H40.875V6.778h1.112v2.8H43.06v-2.8h1.122v6.614H43.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.915,6.778h2.654v.907H46.027V9.578h1.1v.9h-1.1v2.01h1.542v.907H44.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.481,11.294h.888L49.93,8.641h-.01Zm-1.4,2.1,1.249-6.614H50.6l1.258,6.614H50.72l-.205-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.418,6.778H53.53v5.707h1.327v.907H52.418Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,6.778h2.956v.907h-.917v5.707H55.619V7.685H54.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.459,10.475H59.386v2.917H58.274V6.778h1.112v2.8h1.073v-2.8h1.122v6.614H60.459Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.342,21h.888l-.439-2.654h-.01Zm-1.395,2.1L24.2,16.479h1.268l1.259,6.614H25.581l-.2-1.21H24.2L24,23.093Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.216,18.938v4.156h-.937V16.48h1.093l1.2,3.794V16.48H30.5v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.813,22.186c.458,0,.634-.273.634-.673V18.05a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.419,1.776-1.61,1.776H31.232V16.48h1.717c1.191,0,1.61.751,1.61,1.775",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.813,19.006l-.624,4.087H37.145l-.888-6.614H37.33l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01l.507-4.195h.936l-.858,6.614H39.476l-.653-4.087Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.966,16.479H44.62v.907H43.078v1.893h1.1v.9h-1.1v2.01H44.62v.907H41.966Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.313,16.479h1.112v5.707h1.327v.907H45.313Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.357,16.479h1.112v5.707H50.8v.907H48.357Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.561,
    height: 0.897,
    transform: "translate(50.651 19.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.987,20.118v2.068h.488a.479.479,0,0,0,.547-.537v-1c0-.351-.166-.536-.556-.536Zm0-.849h.391a.468.468,0,0,0,.526-.537v-.809a.468.468,0,0,0-.536-.537h-.381Zm-1.112-2.79h1.61c1.112,0,1.483.517,1.483,1.453V18.6a.963.963,0,0,1-.664,1.054,1,1,0,0,1,.83,1.1v.879c0,.936-.42,1.453-1.532,1.453H52.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.788,16.479h2.654v.907H57.9v1.893H59v.9H57.9v2.01h1.542v.907H56.788Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(60.136 16.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.926,18.938v4.156h-.937V16.48h1.093l1.2,3.794V16.48h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.619,19.562H69.2v3.531h-.8v-.721a1,1,0,0,1-1.064.8c-.956,0-1.395-.76-1.395-1.785v-3.2A1.567,1.567,0,0,1,67.609,16.4c1.23,0,1.591.683,1.591,1.659v.585H68.185v-.673c0-.41-.156-.644-.556-.644s-.576.283-.576.683v3.551c0,.4.166.683.547.683.36,0,.546-.2.546-.634V20.44h-.527Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG03);
export default __webpack_public_path__ + "static/media/G03.d68db4e61f228c105d2d3e69a94af135.svg";
export { ForwardRef as ReactComponent };